export default (page, index, setPage) => {
  let newPage = page;
  let indexArtisan = newPage.indexOf(index);
  if (indexArtisan > -1) {
    newPage.splice(indexArtisan, 1);
  }
  setPage([...newPage]);
};
